<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="productAttributeValueHeaders"
        :items="admin.productAttributeValueList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.productAttributeValueList.length == 0"
        :hide-default-header="admin.productAttributeValueList.length == 0"
      >
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeDescription(item.attributeId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProductAttributeValue"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        productAttributeValueHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'VALUE', value: 'value' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProductAttributeValueSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProductAttributeValueSelectionModel',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * returns the description for given attributeId
       */
      getAttributeDescription(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Creates a new Component
       */
      addNewProductAttributeValue() {
        this.$store.commit('admin/setSelectedProductAttributeValue', {
          id: 'new',
          productId: this.admin.selectedProduct.id,
          attributeId: 0,
          value: ''
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit(
            'admin/setSelectedProductAttributeValue',
            data.item
          );
          this.$store.dispatch(
            'admin/getAttributeValueList',
            data.item.attributeId
          );
        } else {
          this.$store.commit('admin/setSelectedProductAttributeValue', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProductAttributeValueSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
